<template>
    <div class="div-ts-table">
        <slot :table="table" :page="page" name="table"></slot>
        <div class="div-ts-table-pagination">
            <el-pagination @current-change="handleCurrentChange"
                        @size-change="handleSizeChange"
                        :current-page="page.pageNum"
                        :page-sizes="pageSizes"
                        :page-size="page.pageSize"
                        :total="page.total"
                        :pager-count="5"
                        :class="['pagination',position]"
                        :layout="layout"
                        v-if="isPage">
            </el-pagination>
        </div>
    </div>
</template>

<script>
    import qs from 'qs';

    export default {
        name: 'TsTable',
        props: {
            hasSearch: { type: Boolean, default: false },
            isMoreShow: { type: Boolean, default: false },
            isPage: { type: Boolean, default: true },
            pageSizes: { type: Array, default: () => [10, 20, 30, 40, 50] },
            tsTable: Object,
            pageSize: Number,
            searchPage: Object,
            layout: {
                type: String,
                default: 'total, sizes, prev, pager, next, jumper'
            },
            indices: { type: Boolean, default: true },
            position: { type: String, default: 'right' },
            notEncode: { type: Boolean, default: true }
        },
        data() {
            return {
                tsTableClass: '',
                table: [],
                page: {
                    pageNum: 1,
                    pageSize: 10,
                    total: 0
                },
                searchObj: {}
            };
        },
        async created() {
            if (this.isPage) {
                this.page.pageSize = this.pageSize || 10;
            } else {
                this.page.pageSize = 99;
            }
            await this.getTable();
        },
        watch: {
            'tsTable.updateFlag': function () {
                this.searchObj = this.tsTable.searchObj;
                this.getTable(0);
            },
            'tsTable.updateFlag1': function () {
                this.searchObj = this.tsTable.searchObj;
                this.getTable();
            },
            'tsTable.updateFlag2': function () {
                this.searchObj = this.tsTable.searchObj;
                if (this.tsTable.table.length > 1) {
                    this.getTable();
                } else {
                    this.getTable(this.page.pageNum - 2)
                }
            },
            'tsTable.url': function () {
                this.searchObj = this.tsTable.searchObj;
                this.getTable(0);
            },
            'tsTable.table': function () {
                this.table = this.tsTable.table;
            },
            'page.total': function () {
                this.updatePage();
            },
            searchPage() {
                this.page = this.searchPage;
            },
            pageSize() {
                this.page.pageSize = this.pageSize || 10;
                this.page.pageNum = 0;
                this.getTable(0);
            }
        },
        methods: {
            async getTable(n = -1) {
                let page = {
                    pageNum: n,
                    pageSize: this.page.pageSize
                };
                if (page.pageNum < 0) {
                    page.pageNum = this.page.pageNum - 1;
                } else {
                    this.page.pageNum = page.pageNum + 1
                }
                this.searchObj = {};
                Object.keys(this.tsTable.searchObj).forEach(e => {
                    if (!this.utils.isEmpty(this.tsTable.searchObj[e])) {
                        this.searchObj[e] = this.tsTable.searchObj[e];
                    }
                });
                const { data } = await this.qGet({
                    notEncode: this.notEncode,
                    url: `${this.tsTable.url}?${qs.stringify(Object.assign(this.searchObj,
                        page), { indices: this.indices })}`
                }).catch(e => console.error(e));
                this.table = data.datas || data.supplierList
                    || data.supplierGradleList || data.goods.dataList;
                if (data.goods !== undefined && data.goods.total !== undefined) {
                    data.page = data.goods.page;
                    data.total = data.goods.total;
                }
                this.page = {
                    pageNum: data.page !== undefined ? data.page + 1 : this.page.pageNum,
                    pageSize: this.page.pageSize,
                    total: data.total !== undefined ? data.total : this.page.total
                };
                this.updatePage();
                this.$emit('updateTable', { table: this.table, page: this.page });
            },
            async handleCurrentChange(e) {
                this.page.pageNum = e;
                this.$emit('loadingChange', true);
                await this.getTable();
            },
            async handleSizeChange(e) {
                this.page.pageSize = e;
                this.$emit('loadingChange', true);
                await this.getTable(0);
            },
            updatePage() {
                this.$emit('updatePage', { total: this.page.total });
            }
        }
    };
</script>

<style lang="scss">
    .div-ts-table {
        // display: flex;
        // flex-direction: column;
    }
    .div-ts-table-pagination {
        display: block;
        padding-top: 10px;
    }
</style>
